import { useState } from 'react';

interface IUsePeriodFilterResult {
  open: boolean;
  year?: number;
  week?: number;
  openFilterCard: () => void;
  closeFilterCard: () => void;
  changeYear: (value?: number) => void;
  changeWeek: (value?: number) => void;
  // Toolbar's week selector: clearing it resets both year and week, picking a week only sets the week.
  onWeekSelect: (value?: string | number) => void;
}

export function usePeriodFilter(): IUsePeriodFilterResult {
  const [open, setOpen] = useState<boolean>(false);
  const [year, setYear] = useState<number | undefined>(undefined);
  const [week, setWeek] = useState<number | undefined>(undefined);

  const openFilterCard = (): void => {
    setOpen(true);
  };

  const closeFilterCard = (): void => {
    setOpen(false);
  };

  const changeYear = (value?: number): void => {
    setYear(value);
  };

  const changeWeek = (value?: number): void => {
    setWeek(value);
  };

  const onWeekSelect = (value?: string | number): void => {
    if (!value) {
      setYear(undefined);
      setWeek(undefined);
    } else {
      setWeek(value as number);
    }
  };

  return { open, year, week, openFilterCard, closeFilterCard, changeYear, changeWeek, onWeekSelect };
}
